
import { defineComponent, ref } from 'vue';
import { useList } from '@/hooks/use-list/index';
import warehouseInfoDialog from './components/warehouse-info-dialog/index.vue';
import { IWarehousePageListItem, IWarehousePageReq } from '@/api/system-config/type.d';
import { getWarehouseList, deleteWarehouse } from '@/api/system-config/index';
import { ElMessageBox } from 'element-plus';
import usePermissionConfig from './use-permission-config';

export default defineComponent({
  components: {
    warehouseInfoDialog,
  },
  setup() {
    const {
      params,
      tableData,
      tableTotal,
      tableLoading,
      handleSearch,
      handleReset,
      handleSizeChange,
      handleCurrentChange,
    } = useList<IWarehousePageListItem, IWarehousePageReq>({
      request: {
        api: getWarehouseList,
        params: {
          pageNum: 1,
          pageSize: 10,
        },
      },
    });
    handleSearch();

    // 仓库信息模态框
    const warehouseType = ref<string>('add');
    // 仓库弹窗显示
    const warehouseInfoDialogVisible = ref<boolean>(false);
    const rowItem = ref({});
    const warehouseModel = (type: string, row?: IWarehousePageListItem) => {
      if (type === 'edit') {
        rowItem.value = row || {};
        warehouseType.value = 'edit';
      } else {
        warehouseType.value = 'add';
      }
      warehouseInfoDialogVisible.value = true;
    };

    // 删除仓库项
    const deleteWarehouseItem = async (row: IWarehousePageListItem) => {
      try {
        await ElMessageBox.confirm(`确定删除${row.name}？`, '提示', {
          confirmButtonText: '保存',
          cancelButtonText: '取消',
        });
        await deleteWarehouse(row.warehouseId as string);
        handleSearch(params.value.pageNum);
      } catch (error) {
        console.log(error);
      }
    };

    const permissionConfig = usePermissionConfig();

    return {
      params,
      tableData,
      tableTotal,
      tableLoading,
      handleSearch,
      handleReset,
      handleSizeChange,
      handleCurrentChange,
      warehouseInfoDialogVisible,
      warehouseModel,
      rowItem,
      warehouseType,
      deleteWarehouseItem,
      permissionConfig,
    };
  },
});
